import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { StoryblokHelperService } from '../../../services/storyblok-helper.service';
import { StoryblokCdnPipe } from '../../pipes/storyblok-cdn.pipe';
import { StoryblokDirective } from '../../storyblok.directive';

@Component({
  selector: 'app-blog-post-link-list-item',
  templateUrl: './blog-post-link-list-item.component.html',
  styleUrls: ['./blog-post-link-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoryblokDirective, RouterLink, DatePipe, StoryblokCdnPipe],
})
export class BlogPostLinkListItemComponent {
  private storyblokHelperService = inject(StoryblokHelperService);
  readonly post = input<ISbStoryData & { _editable: string }>(undefined);
  readonly index = input<number>(undefined);

  readonly topic = computed(() => {
    const post = this.post();
    if (!post) return;
    if (!post.content.topic) return undefined;
    const topics = this.storyblokHelperService.getGlobalData('articleTopics');
    return topics.find(re => re.uuid === post.content.topic);
  });
}
